const styles = theme => ({
  page__header__title: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    gap: 8,
    padding: '16px 24px',
    borderRadius: '16px',
    boxShadow:
      '0px 0px 2px 0px rgba(145, 158, 171, 0.12), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: 12,
      padding: '16px',
      textAlign: 'center',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '12px',
      gap: 10,
    },
  },
  inviteTexts: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    [theme.breakpoints.down('sm')]: {
      flexGrow: 0,
      alignItems: 'center',
    },
  },
  inviteLearners: {
    fontSize: '14px',
    fontWeight: 500,
    [theme.breakpoints.down('sm')]: {
      fontSize: '13px',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px',
    },
  },
  inviteLearnersDescription: {
    fontSize: '14px',
    fontWeight: 400,
    color: '#637381',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
      textAlign: 'center',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '11px',
    },
  },
})

export default styles
